import { DateTime } from "luxon";
import { IntervalModel } from "model";

export const getLatestReportableInterval = (intervals: IntervalModel[]) => {
  const now = DateTime.now().toISO();

  let latestReportableInterval = intervals.slice(-1)[0];
  const reversedIntervals = intervals.slice().reverse();

  for (const interval of reversedIntervals) {
    const intervalDay = interval.start.startOf("day").toISO() || "";

    if (now >= intervalDay) {
      latestReportableInterval = interval;
      break;
    }
  }

  return latestReportableInterval;
};
